import get from 'lodash/get'
import { FieldErrors } from 'react-hook-form/dist/types'
import { IMotorCarrierInsuranceContactInput } from 'types/graphqlTypes'
import { TAddInsuranceContactInformationModalSchema } from './AddInsuranceContactInformationModalSchema'

export const getErrorMessage = <
  T extends FieldErrors<TAddInsuranceContactInformationModalSchema>,
  K extends keyof T
>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

interface IInsuranceDocument {
  file: any
  fileFileName: string
}

export const parseData = (data: TAddInsuranceContactInformationModalSchema) => {
  const { insuranceDocuments } = data || {}
  const docs = insuranceDocuments as IInsuranceDocument[]

  // removes UUID from files
  const mappedInsuranceDocuments = docs?.map(({ file, fileFileName }: IInsuranceDocument) => ({
    document: file,
    documentFileName: fileFileName,
  }))

  const input = {
    insuranceContacts: [
      {
        ...data,
        insuranceDocuments: mappedInsuranceDocuments,
      } as IMotorCarrierInsuranceContactInput,
    ],
  }

  return {
    input,
  }
}
